/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BumpSerie
 */
export interface BumpSerie {
    /**
     * 
     * @type {string}
     * @memberof BumpSerie
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BumpSerie
     */
    modelId: string;
    /**
     * 
     * @type {number}
     * @memberof BumpSerie
     */
    index: number;
    /**
     * 
     * @type {number}
     * @memberof BumpSerie
     */
    firstFrame: number;
    /**
     * 
     * @type {number}
     * @memberof BumpSerie
     */
    lastFrame: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof BumpSerie
     */
    framesOrder: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof BumpSerie
     */
    extension: string;
    /**
     * 
     * @type {number}
     * @memberof BumpSerie
     */
    imageWidth: number;
    /**
     * 
     * @type {number}
     * @memberof BumpSerie
     */
    imageOutputWidth: number;
    /**
     * 
     * @type {number}
     * @memberof BumpSerie
     */
    imageHeight: number;
    /**
     * 
     * @type {number}
     * @memberof BumpSerie
     */
    imageOutputHeight: number;
}

export function BumpSerieFromJSON(json: any): BumpSerie {
    return BumpSerieFromJSONTyped(json, false);
}

export function BumpSerieFromJSONTyped(json: any, ignoreDiscriminator: boolean): BumpSerie {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'modelId': json['modelId'],
        'index': json['index'],
        'firstFrame': json['firstFrame'],
        'lastFrame': json['lastFrame'],
        'framesOrder': json['framesOrder'],
        'extension': json['extension'],
        'imageWidth': json['imageWidth'],
        'imageOutputWidth': json['imageOutputWidth'],
        'imageHeight': json['imageHeight'],
        'imageOutputHeight': json['imageOutputHeight'],
    };
}

export function BumpSerieToJSON(value?: BumpSerie | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'modelId': value.modelId,
        'index': value.index,
        'firstFrame': value.firstFrame,
        'lastFrame': value.lastFrame,
        'framesOrder': value.framesOrder,
        'extension': value.extension,
        'imageWidth': value.imageWidth,
        'imageOutputWidth': value.imageOutputWidth,
        'imageHeight': value.imageHeight,
        'imageOutputHeight': value.imageOutputHeight,
    };
}


